import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';

import { dropdownStyle } from '../../../auth';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { invitePatient, updateWellbeingPlan } from '../../../store/ai2';
import { useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';

import cellPhoneIcon from '../../../assets/img/cell-phone.png';
import loopArrowsIcon from '../../../assets/img/loop-arrows.png';
import backArrowIcon from '../../../assets/img/backarrow.png';
import greenZIcon from '../../../assets/img/greenZ.png';
import redZIcon from '../../../assets/img/redZ.png';

export const WellbeingPlan = () => {
  const { wellbeingPlan, patientProfile } = useSelector(
    (state) => state.patientProfile,
  );
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const access_token = searchParams.get('access_token');

  const dispatch = useDispatch();

  const [setShowDropdown] = useState(false);
  const [setCustomDropdowns] = useState([]);
  const [positiveSignatureFields, setPositiveSignatureFields] = useState([]);
  const [earlyWarningsFields, setEarlyWarningsFields] = useState([]);
  const [modalshow, setModalShow] = useState(false);
  const [phone, setPhone] = useState(null);

  const handleClose = () => {
    setModalShow(false);
  };

  const onSubmit = () => {
    dispatch(
      invitePatient(
        access_token,
        selectedTenancy,
        phone,
        patientProfile.clinic,
      ),
    );

    handleClose();
  };

  if (phone === null && modalshow) {
    setPhone(patientProfile.phone ?? '');
  }

  const handleAddAnotherPositiveSignatureField = () => {
    setPositiveSignatureFields([
      ...positiveSignatureFields,
      { id: Date.now(), type: 'option', value: '' },
    ]);
  };

  const handleAddAnotherEarlyWarningsField = () => {
    setEarlyWarningsFields([
      ...earlyWarningsFields,
      { id: Date.now(), type: 'option', value: '' },
    ]);
  };

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const user_sig_signs = wellbeingPlan?.user_sig_sign_options[0] ?? [];
  const default_sig_signs = wellbeingPlan?.sig_sign_options ?? {
    good_signs: [],
    warning_signs: [],
  };

  function inviteModal() {
    setModalShow(true);
  }

  function removeField(field, type) {
    //remove from redux and then update API

    if (type === 'positiveSignature') {
      let newPstve = positiveSignatureFields.filter((x) => x.id !== field.id);
      setPositiveSignatureFields(newPstve);
      dispatch(
        updateWellbeingPlan(
          access_token,
          selectedTenancy,
          newPstve.map((x) => x.value),
          earlyWarningsFields.map((x) => x.value),
          wellbeingPlan,
        ),
      );
    } else if (type === 'earlyWarnings') {
      let newWarn = earlyWarningsFields.filter((x) => x.id !== field.id);
      setEarlyWarningsFields(newWarn);
      dispatch(
        updateWellbeingPlan(
          access_token,
          selectedTenancy,
          positiveSignatureFields.map((x) => x.value),
          newWarn.map((x) => x.value),
          wellbeingPlan,
        ),
      );
    }
  }

  if (wellbeingPlan && user_sig_signs && default_sig_signs && patientProfile) {
    if (
      earlyWarningsFields.length === 0 &&
      user_sig_signs?.warning_signs?.length > 0
    ) {
      setEarlyWarningsFields(
        user_sig_signs.warning_signs?.map((x, i) => {
          return { id: i, type: 'option', value: x };
        }),
      );
    }

    if (
      positiveSignatureFields.length === 0 &&
      user_sig_signs?.good_signs?.length > 0
    ) {
      setPositiveSignatureFields(
        user_sig_signs?.good_signs?.map((x, i) => {
          return { id: i, type: 'option', value: x };
        }),
      );
    }

    const addPositiveSignatureField = () => {
      setPositiveSignatureFields(() => [
        ...positiveSignatureFields,
        { id: Date.now(), type: 'text', value: '' },
      ]);
    };

    const addEarlyWarningsField = () => {
      setEarlyWarningsFields(() => [
        ...earlyWarningsFields,
        { id: Date.now(), type: 'text', value: '' },
      ]);
    };

    const handleChange = (fieldType, id, value) => {
      if (fieldType === 'positiveSignature') {
        const newPstve = positiveSignatureFields.map((field) =>
          field.id === id ? { ...field, value } : field,
        );
        setPositiveSignatureFields(newPstve);
        dispatch(
          updateWellbeingPlan(
            access_token,
            selectedTenancy,
            newPstve.map((x) => x.value),
            earlyWarningsFields.map((x) => x.value),
            wellbeingPlan,
          ),
        );
      } else if (fieldType === 'earlyWarnings') {
        const newWarn = earlyWarningsFields.map((field) =>
          field.id === id ? { ...field, value } : field,
        );
        setEarlyWarningsFields(newWarn);
        dispatch(
          updateWellbeingPlan(
            access_token,
            selectedTenancy,
            positiveSignatureFields.map((x) => x.value),
            newWarn.map((x) => x.value),
            wellbeingPlan,
          ),
        );
      }
    };

    const handleCustomInputChange = (index, value) => {
      setCustomDropdowns((prevDropdowns) =>
        prevDropdowns.map((dropdown, i) =>
          i === index ? { ...dropdown, value } : dropdown,
        ),
      );
      dispatch(
        updateWellbeingPlan(
          access_token,
          selectedTenancy,
          positiveSignatureFields.map((x) => x.value),
          earlyWarningsFields.map((x) => x.value),
          wellbeingPlan,
        ),
      );
    };

    //these are a standard set to get started with
    const xOptions = default_sig_signs
      ? default_sig_signs.good_signs?.map((x, i) => {
          return {
            labelKey: x,
            value: x,
          };
        })
      : [];

    if (user_sig_signs?.good_signs?.length > 0) {
      xOptions.push(
        ...user_sig_signs?.good_signs
          ?.filter((x) => default_sig_signs.good_signs.indexOf(x) === -1)
          .map((x) => {
            return {
              labelKey: x,
              value: x,
            };
          }),
      );
    }

    const yOptions = default_sig_signs
      ? default_sig_signs.warning_signs.map((x, i) => {
          return {
            labelKey: x,
            value: x,
          };
        })
      : [];

    if (user_sig_signs?.warning_signs?.length > 0) {
      yOptions.push(
        ...user_sig_signs?.warning_signs
          ?.filter((x) => default_sig_signs.warning_signs.indexOf(x) === -1)
          .map((x) => {
            return {
              labelKey: x,
              value: x,
            };
          }),
      );
    }

    return (
      <>
        <Modal
          show={modalshow}
          onHide={() => handleClose()}
          animation={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          id="viewPatientModal"
        >
          <Modal.Header className="modal-header-transp">
            <Modal.Title>
              <button onClick={() => handleClose()} className="btn simpleLink">
                <img src={backArrowIcon} alt="backarrow" className="imgArrow" />
                Back to Wellbeing plan
              </button>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              {phone ? (
                <div className="mb-5">
                  <p>
                    <b>Please note:</b> Phone number from Caremappr has been
                    automatically filled, it can be overwritten now if its not
                    accurate
                  </p>
                </div>
              ) : (
                <div></div>
              )}
              <div className="form-group">
                <label htmlFor="email">Phone number</label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  placeholder="Enter phone number"
                  name="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>
            <div className="float-right mt-3 mb-3">
              <button
                type="button"
                className="m-3 btn btnSecondary"
                onClick={() => handleClose()}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="mt-3 mb-3 btn btnPrimary"
                onClick={() => onSubmit()}
              >
                Send
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Container fluid>
          <div>
            {wellbeingPlan.app_active ? (
              <Row>
                <Col xs={12} lg={4} xl={6}>
                  <h1 className="heading1 mt-3">Shared wellbeing plan</h1>
                </Col>
                <Col xs={12} lg={8} xl={6}>
                  <div className="specialInfoBlock mt-4 mb-1">
                    <Row>
                      <Col md={12} lg={6}>
                        <div className="txtDescription mb-1">
                          <img src={loopArrowsIcon} alt=""></img>
                          Patient app active
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col xs={12} lg={4} xl={6}>
                  <h1 className="heading1 mt-3">Shared wellbeing plan</h1>
                </Col>
                <Col xs={12} lg={8} xl={6}>
                  <div className="specialInfoBlock mt-4 mb-1">
                    <Row>
                      <Col md={12} lg={6}>
                        <div className="txtDescription mb-1">
                          <img src={loopArrowsIcon} alt=""></img>
                          Patient app not active
                        </div>
                        <p>
                          To receive patient data from your patient they must
                          have the CareMappr App installed.
                        </p>
                      </Col>
                      <Col md={12} lg={6}>
                        <div className="float-right mt-3">
                          <button
                            onClick={() => inviteModal()}
                            className="btn btnPrimary btnPrimaryDark btn-long btn-sm"
                          >
                            <img
                              className="mr-15"
                              src={cellPhoneIcon}
                              alt=""
                            ></img>
                            Send code to patient
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            )}

            <Card className="cardType1 cardPurple mt-3">
              <Card.Body>
                <h2 className="heading1 mb-4">
                  Set Signature signs for {patientProfile.first_name}
                </h2>
                <Row>
                  <Col sm={12} xl={5}>
                    <p className="mb-4">
                      Signature signs added here will be available through the
                      CareMappr app for {patientProfile.first_name} to report
                      back to you with, and will be displayed on the wellbeing
                      timeline.
                    </p>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12} md={6} xxl={5}>
                    <div className="mb-5">
                      <div>
                        <div className="txtDescription">
                          <img src={greenZIcon} alt="Green Z"></img>
                          Set some positive signature signs that bring your
                          patient joy
                        </div>
                      </div>
                      <div className="divSelect">
                        {positiveSignatureFields.map((field) => (
                          <div className="mb-3" key={field.id}>
                            {field.type === 'option' ? (
                              <Row>
                                <div className="col-11">
                                  <Form.Select
                                    style={dropdownStyle}
                                    value={field.value}
                                    onChange={(e) =>
                                      handleChange(
                                        'positiveSignature',
                                        field.id,
                                        e.target.value,
                                      )
                                    }
                                    id={field.id}
                                  >
                                    {xOptions.map((x, i) => {
                                      return (
                                        <option
                                          key={x.labelKey}
                                          value={x.value}
                                        >
                                          {x.value}
                                        </option>
                                      );
                                    })}
                                  </Form.Select>
                                </div>
                                <button
                                  className=" btn btnRemove col-1 "
                                  onClick={() =>
                                    removeField(field, 'positiveSignature')
                                  }
                                >
                                  x
                                </button>
                              </Row>
                            ) : (
                              <Row>
                                <div className="col-11">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={field.value}
                                    onBlur={(e) =>
                                      handleChange(
                                        'positiveSignature',
                                        field.id,
                                        e.target.value,
                                      )
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        'positiveSignature',
                                        field.id,
                                        e.target.value,
                                      )
                                    }
                                  />
                                </div>{' '}
                                <button
                                  className=" btn btnRemove col-1 "
                                  onClick={() =>
                                    removeField(field, 'positiveSignature')
                                  }
                                >
                                  x
                                </button>
                              </Row>
                            )}
                          </div>
                        ))}
                        <div className="">
                          <a
                            className="simpleLink"
                            onClick={handleAddAnotherPositiveSignatureField}
                          >
                            Add another
                          </a>
                        </div>
                        <div className="">
                          <a
                            className="simpleLink"
                            onClick={addPositiveSignatureField}
                          >
                            Type your own input
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={12} md={6} xxl={5}>
                    <div className="mb-4">
                      <div>
                        <div className="txtDescription">
                          <img src={redZIcon} alt="Red Z"></img>
                          Set early warnings signs
                        </div>
                      </div>
                      <div className="divSelect">
                        {earlyWarningsFields.map((field) => (
                          <div className="mb-3" key={field.id}>
                            {field.type === 'option' ? (
                              <Row>
                                <div className="col-11">
                                  <Form.Select
                                    style={dropdownStyle}
                                    value={field.value}
                                    onChange={(e) =>
                                      handleChange(
                                        'earlyWarnings',
                                        field.id,
                                        e.target.value,
                                      )
                                    }
                                    id={field.id}
                                  >
                                    {yOptions.map((x, i) => {
                                      return (
                                        <option
                                          key={x.labelKey}
                                          value={x.value}
                                        >
                                          {x.value}
                                        </option>
                                      );
                                    })}
                                  </Form.Select>
                                </div>
                                <button
                                  className=" btn btnRemove col-1 "
                                  onClick={() =>
                                    removeField(field, 'earlyWarnings')
                                  }
                                >
                                  x
                                </button>
                              </Row>
                            ) : (
                              <Row>
                                <div className="col-11">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={field.value}
                                    onChange={(e) =>
                                      handleChange(
                                        'earlyWarnings',
                                        field.id,
                                        e.target.value,
                                      )
                                    }
                                  />{' '}
                                </div>
                                <button
                                  className=" btn btnRemove col-1 "
                                  onClick={() =>
                                    removeField(field, 'earlyWarnings')
                                  }
                                >
                                  x
                                </button>
                              </Row>
                            )}
                          </div>
                        ))}
                        <div className="">
                          <a
                            className="simpleLink"
                            onClick={handleAddAnotherEarlyWarningsField}
                          >
                            Add another
                          </a>
                        </div>
                        <div className="">
                          <a
                            className="simpleLink"
                            onClick={addEarlyWarningsField}
                          >
                            Type your own input
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        </Container>
      </>
    );
  } else {
    return (
      <>
        <Container fluid>
          <div className="mySpinner">
            <div>
              <Spinner animation="border" role="status"></Spinner>
              <span>
                <br />
                Loading...
              </span>
            </div>
          </div>
        </Container>
      </>
    );
  }
};
